import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { ScheduleType } from "../../models";
import { remove } from "../../api/generic-api";
import { RQ } from "../../globals/enums";
import { deleteEntity } from "../../utils";

export const useDeleteScheduleType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("schedule-types", id), {
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        RQ.SCHEDULE_TYPES,
        (scheduleTypes: ScheduleType[] | undefined) => {
          enqueueSnackbar("Schedule Type Deleted", { variant: "success" });
          return !scheduleTypes
            ? []
            : deleteEntity<ScheduleType>(scheduleTypes, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Schedule Type Deleting Error", { variant: "error" });
    },
  });
};
